export default __webpack_public_path__ + "static/media/close-grey.2e381162.svg";